<template>
    <div>
        <h1 class="mb-100">{{ $t('pages.password-reset.title') }}</h1>
        <el-form @submit="submit">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="form-row">
                    <div class="col-12 col-xl-10">
                        <el-input v-model="data.password" ref="password" type="password" rule="required" :name="$t('form-elements.new_password')" :label="$t('form-elements.new_password')" :placeholder="$t('form-elements.new_password_placeholder')"></el-input>
                    </div>
                    <div class="col-12 col-xl-10 mb-32">
                        <el-input v-model="data.password_repeat" type="password" :rule="{required: true, confirmed: data.password}" :name="$t('form-elements.password_repeat')" :label="$t('form-elements.password_repeat')" :placeholder="$t('form-elements.password_repeat_placeholder')"></el-input>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <button class="btn btn-primary d-flex" v-bind:class="{ disabled : loading }">
                    {{ $t('pages.password-reset.cta_submit') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>
    </div>
</template>

<script>
import { ElInput, ElForm, ElError } from '@/components/forms'

export default {
    name: 'page-password-reset',

    components: { ElInput, ElForm, ElError },

    data: () => ({
        loading: false,
        success: false,
        server_error: null,
        passwordRule: '',
        data: {
            email: null,
            token: null,
            password: null,
        }
    }),

    mounted() {
        this.data.email = this.$route.query.email
        this.data.token = this.$route.query.token
    },
    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.$store.dispatch('user/passwordReset', this.data).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.$router.push({ name: 'sleep-schedule' })
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    }
}
</script>
